import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/shadcn/alert-dialog';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from './shadcn/checkbox';
import { Label } from './shadcn/label';
import { CheckedState } from '@radix-ui/react-checkbox';

type Props = {
  children: ReactNode;
  onConfirm: () => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  description?: string;
  confirmText?: string;
  checkboxText?: string;
};

export function DeleteAlertDialog({
  children,
  open,
  onOpenChange,
  onConfirm,
  title,
  checkboxText,
  description,
  confirmText,
}: Props) {
  const { t } = useTranslation();
  const [localOpen, onLocalConfirm] = useState(false);
  const [checkedState, setCheckedState] = useState<CheckedState>(false);

  return (
    <AlertDialog open={open || localOpen} onOpenChange={onOpenChange || onLocalConfirm}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex justify-start items-center gap-2">
          <Checkbox checked={checkedState} onCheckedChange={setCheckedState} id="understand" />
          <Label htmlFor="understand">{checkboxText}</Label>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            disabled={checkedState !== true}
            onClick={() => {
              onConfirm();
            }}
            variant={'destructive'}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
